export const mapString = (stringValue, mapCallback) => [...stringValue].map(mapCallback).join('');
